/** Returns a function that will only be evaluated once, but will return the same result on subsequent calls. */
export function once<Args extends any[], Result>(fn: (...args: Args) => Result): (...args: Args) => Result {
    let done = false;
    let result: Result;
    return (...args: Args) => {
        if (!done) {
            result = fn(...args);
            done = true;
        }
        return result;
    };
}
